import { IPrivateTrade, IPrivateInetTradeReport, IPrivateGeniumInetTradeReport } from '../api/PrivateTypes';
import { IAlertsSummary, IAlertsSummaryPerClientId, IAlertsSummaryPerTraderId } from '../api/ReportTypes';

// REQUEST CANCELLED TRADES.
export const REQUEST_CANCELLED_TRADES_WAITING = 'REQUEST_CANCELLED_TRADES_WAITING';
export const REQUEST_CANCELLED_TRADES_SUCCESS = 'REQUEST_CANCELLED_TRADES_SUCCESS';
export const REQUEST_CANCELLED_TRADES_FAILURE = 'REQUEST_CANCELLED_TRADES_FAILURE';

interface IRequestCancelledTradesWaitingAction {
    type: typeof REQUEST_CANCELLED_TRADES_WAITING,
    payload: {
        datePair: string
    }
}

interface IRequestCancelledTradesSuccessAction {
    type: typeof REQUEST_CANCELLED_TRADES_SUCCESS,
    payload: {
        datePair: string,
        cancelledTrades: IPrivateTrade[]
    }
}

interface IRequestCancelledTradesFailureAction {
    type: typeof REQUEST_CANCELLED_TRADES_FAILURE,
    payload: {
        datePair: string,
        error: string
    }
}

// REQUEST BROKEN TRADE REPORTS
export const REQUEST_BROKEN_TRADE_REPORTS_WAITING = 'REQUEST_BROKEN_TRADE_REPORTS_WAITING';
export const REQUEST_BROKEN_TRADE_REPORTS_SUCCESS = 'REQUEST_BROKEN_TRADE_REPORTS_SUCCESS';
export const REQUEST_BROKEN_TRADE_REPORTS_FAILURE = 'REQUEST_BROKEN_TRADE_REPORTS_FAILURE';

interface IRequestBrokenTradeReportsWaitingAction {
    type: typeof REQUEST_BROKEN_TRADE_REPORTS_WAITING,
    payload: {
        datePair: string
    }
}

interface IRequestBrokenTradeReportsSuccessAction {
    type: typeof REQUEST_BROKEN_TRADE_REPORTS_SUCCESS,
    payload: {
        datePair: string,
        brokenInetTradeReports: IPrivateInetTradeReport[],
        brokenGeniumTradeReports: IPrivateGeniumInetTradeReport[]
    }
}

interface IRequestBrokenTradeReportsFailureAction {
    type: typeof REQUEST_BROKEN_TRADE_REPORTS_FAILURE,
    payload: {
        datePair: string,
        error: string
    }
}

// REQUEST ALERTS SUMMARY
export const REQUEST_ALERTS_SUMMARY_WAITING = 'REQUEST_ALERTS_SUMMARY_WAITING';
export const REQUEST_ALERTS_SUMMARY_SUCCESS = 'REQUEST_ALERTS_SUMMARY_SUCCESS';
export const REQUEST_ALERTS_SUMMARY_FAILURE = 'REQUEST_ALERTS_SUMMARY_FAILURE';

interface IRequestAlertsSummaryWaitingAction {
    type: typeof REQUEST_ALERTS_SUMMARY_WAITING,
    payload: {
        datePair: string
    }
}

interface IRequestAlertsSummarySuccessAction {
    type: typeof REQUEST_ALERTS_SUMMARY_SUCCESS,
    payload: {
        datePair: string,
        alertsSummary: IAlertsSummary[]
    }
}

interface IRequestAlertsSummaryFailureAction {
    type: typeof REQUEST_ALERTS_SUMMARY_FAILURE,
    payload: {
        datePair: string,
        error: string
    }
}

// =================================== REQUEST TRADER ALERTS SUMMARY ===================================
export const REQUEST_ALERTS_SUMMARY_PER_TRADER_ID_WAITING = 'REQUEST_ALERTS_SUMMARY_PER_TRADER_ID_WAITING';
export const REQUEST_ALERTS_SUMMARY_PER_TRADER_ID_SUCCESS = 'REQUEST_ALERTS_SUMMARY_PER_TRADER_ID_SUCCESS';
export const REQUEST_ALERTS_SUMMARY_PER_TRADER_ID_FAILURE = 'REQUEST_ALERTS_SUMMARY_PER_TRADER_ID_FAILURE';

interface IRequestAlertsSummaryPerTraderIdWaitingAction {
    type: typeof REQUEST_ALERTS_SUMMARY_PER_TRADER_ID_WAITING,
    payload: {
        datePair: string
    }
}

interface IRequestAlertsSummarPerTraderIdySuccessAction {
    type: typeof REQUEST_ALERTS_SUMMARY_PER_TRADER_ID_SUCCESS,
    payload: {
        datePair: string,
        alertsSummaryPerTraderId: IAlertsSummaryPerTraderId[]
    }
}

interface IRequestAlertsSummaryPerTraderIdFailureAction {
    type: typeof REQUEST_ALERTS_SUMMARY_PER_TRADER_ID_FAILURE,
    payload: {
        datePair: string,
        error: string
    }
}

// =================================== REQUEST CLIENT ALERTS SUMMARY ===================================
export const REQUEST_ALERTS_SUMMARY_PER_CLIENT_ID_WAITING = 'REQUEST_ALERTS_SUMMARY_PER_CLIENT_ID_WAITING';
export const REQUEST_ALERTS_SUMMARY_PER_CLIENT_ID_SUCCESS = 'REQUEST_ALERTS_SUMMARY_PER_CLIENT_ID_SUCCESS';
export const REQUEST_ALERTS_SUMMARY_PER_CLIENT_ID_FAILURE = 'REQUEST_ALERTS_SUMMARY_PER_CLIENT_ID_FAILURE';

interface IRequestAlertsSummaryPerClientIdWaitingAction {
    type: typeof REQUEST_ALERTS_SUMMARY_PER_CLIENT_ID_WAITING,
    payload: {
        datePair: string
    }
}

interface IRequestAlertsSummarPerClientIdySuccessAction {
    type: typeof REQUEST_ALERTS_SUMMARY_PER_CLIENT_ID_SUCCESS,
    payload: {
        datePair: string,
        alertsSummaryPerClientId: IAlertsSummaryPerClientId[]
    }
}

interface IRequestAlertsSummaryPerClientIdFailureAction {
    type: typeof REQUEST_ALERTS_SUMMARY_PER_CLIENT_ID_FAILURE,
    payload: {
        datePair: string,
        error: string
    }
}

// EXPORT.
export type ReportActions =
IRequestCancelledTradesWaitingAction
| IRequestCancelledTradesSuccessAction
| IRequestCancelledTradesFailureAction
| IRequestBrokenTradeReportsWaitingAction
| IRequestBrokenTradeReportsSuccessAction
| IRequestBrokenTradeReportsFailureAction
| IRequestAlertsSummaryWaitingAction
| IRequestAlertsSummarySuccessAction
| IRequestAlertsSummaryFailureAction
| IRequestAlertsSummaryPerTraderIdWaitingAction
| IRequestAlertsSummarPerTraderIdySuccessAction
| IRequestAlertsSummaryPerTraderIdFailureAction
| IRequestAlertsSummaryPerClientIdWaitingAction
| IRequestAlertsSummarPerClientIdySuccessAction
| IRequestAlertsSummaryPerClientIdFailureAction;